const state = {
   //lastServedLink: '',
   //servedLinks: [],
   //staticLinks: ['/login', '/logout', '/register', '/signin' ],
   //publicLinks: ['/login', '/register']
};

const mutations = {
   'SET_SERVED_LINK': (state, servedLink) =>  {
      if(!servedLink) { servedLink = '/'; }
      if(state.staticLinks.indexOf(servedLink) == -1) {
         state.lastServedLink = servedLink;
      }
   }
};

const actions = {
   setServedLink: ({ commit }, servedLink) =>  {
      commit('SET_SERVED_LINK', servedLink);
   }
};

const getters= {
   getLastServedLink: (state) => {
      return state.lastServedLink;
   },
   getStaticLinks: (state) => {
      return state.staticLinks;
   },
   isPublicLink: (state) => {
      //let location = window.location.pathname;
      //for(let i = 0; i < state.publicLinks.length; i++){
      //   if(location === state.publicLinks[i]){
      //      return true;
      //   }
      //}
      return false;
   },
   getPublicLinks: (state) => {
      return state.publicLinks;
   },
   getLocation: (state) => {
      return window.location.pathname;
   }
};

export default {
   state,
   mutations,
   actions,
   getters
};


// WEBPACK FOOTER //
// ./src/Banet/store/modules/navigation.js